import React, { useEffect, useState, useCallback, useRef } from "react";
import { debounce } from "lodash";
import { withRouter } from "react-router-dom";
import { useRecoilState, useRecoilValue } from 'recoil';

import VehicleList from "./VehicleList/VehicleList";
import { useAuth } from "../../../../core/contexts/AuthContext";
// import LocationMap from "../../GoogleMap/GoogleMap";
import LocationMap from "../../GoogleMap/GoogleMap_New";
import Spinner from "../../../Common/UI/Spinner/Spinner";
import * as LocationsApi from "../../../Common/Apis/LocationsApi";
import MapWrapper from "../../../Public/Wrapper/MapWrapper";
import MapHeader from "../../../Public/Header/MapHeader";

import { vehicleSearchTypeState, vehicleSearchStrState } from '../../../Common/Store/VehicleSearchStore';


const VehicleLastPosition = (props) => {

  /*
  using mountedRef to avoid the warning below;
  index.js:1 Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
    in AutoRucDialog (at VehicleLastPosition.js:350)
  */
  const mountedRef = useRef(true);


  const { authTokens } = useAuth();

  const [isLoading, setisLoading] = useState(false);
  const [mapData, setmapData] = useState();
  const [searchData, setsearchData] = useState();
  const [selectedVehicle, setselectedVehicle] = useState();
  const [selectedLicence, setselectedLicence] = useState();
  const [isCenter, setisCenter] = useState(true);

  const vehicleType = useRecoilValue(vehicleSearchTypeState);
  const [vehicleSearchStr,] = useRecoilState(vehicleSearchStrState);


  useEffect(() => {

    const loadMapDataIn = async () => {


      if (!vehicleType || vehicleType === "")
        return;

      setisLoading(true);
      setselectedVehicle(null);

      try {
        const resData = await LocationsApi.getAllVehicleLastLocation(
          500,
          vehicleType
        );
        setsearchData(null);
        setmapData(resData.Data);

      } catch (err) {
        console.log("err", err);
      }
      setisLoading(false);
    };

    if (authTokens) {
      loadMapDataIn();
    }

    return () => {
      mountedRef.current = false; // clean up function
    };

  }, [authTokens, vehicleType]);

  useEffect(() => {
    //If ruc license dialog is opened, change the item's information
    if (mapData && selectedLicence) {


      mapData.forEach((item) => {
        if (item.StationId === selectedLicence.StationId) {
          setselectedLicence(item);
        }
      });
    }
  }, [mapData, selectedLicence]);

  const loadSearchData = useCallback(

    debounce((mapData, vehicleSearchStr) => {

      if (mapData && vehicleSearchStr && vehicleSearchStr !== "") {

        let searchVehicle = [];

        searchVehicle = mapData.filter((item) => {
          return chkSearchStr(item, vehicleSearchStr.toLowerCase());
        });

        setsearchData(searchVehicle);
      } else {
        setsearchData(null);
      }
    }, 500), []
  );

  useEffect(() => {
    loadSearchData(mapData, vehicleSearchStr);


  }, [loadSearchData, vehicleSearchStr, mapData]);



  const loadMapData = async () => {
    setisLoading(true);
    setselectedVehicle(null);

    try {
      const resData = await LocationsApi.getAllVehicleLastLocation(500);

      setsearchData(null);
      setmapData(resData.Data);



      //If ruc license dialog is opened, change the item's information
      if (selectedLicence) {
        const _item = resData.Data.find(
          (item) => item.StationId === selectedLicence.StationId
        );
        setselectedLicence(_item);
      }
    } catch (err) {
      console.log("err", err);
    }
    setisLoading(false);
  };

  const chkSearchStr = (item, searchStr) => {

    if (item.VehiclePlate.toLowerCase().indexOf(searchStr) >= 0) {
      return true;
    }
    if (item.VehicleCode.toLowerCase().indexOf(searchStr) >= 0) {
      return true;
    }

    return false;
  };

  const detailViewChange = () => {
    loadMapData();
  };



  const clickedVehicle = useCallback((item) => {


    setisCenter(true);

    if (item.Longitude) {
      setselectedVehicle(item);
    } else {
      setselectedVehicle(null);
    }
  }, []);

  const unSelectVehicle = () => {
    //console.log('unSelectVehicle');
    setisCenter(false);
    setselectedVehicle(null);
  };

  const setHistory = useCallback((item) => {
    //console.log("setHistory.item", item);
    props.history.push(`/history/${item.VehicleId}`);
  }, [props.history]);


  return (
    <MapWrapper
      header={
        <MapHeader
          closeSidebar={true}
          isOnlyRuc={false}
        />
      }
    >

      <div className="row no-gutters">
        <div className="content map-wrapper">
          <div id="map" className="map-full">
            <LocationMap
              zoom={8}
              locations={searchData ? searchData : mapData}
              selectedVehicle={selectedVehicle}
              isCenter={isCenter}              
              isCluster={true}
              isUseMarkerLabel={false}
              isMarker={true} 
              unSelectVehicle={unSelectVehicle}
              selectedHistory={setHistory}
              // selectedStatusCheck={setSelectedStatusCheck}
            />
          </div>

          <div className="row no-gutters">
            <div className="col-md-12">
              <VehicleList
                details={searchData ? searchData : mapData}
                selectedVehicle={selectedVehicle}
                clickedVehicle={clickedVehicle}
                clickedHistory={setHistory}
                detailViewChange={detailViewChange}
                searchStr={vehicleSearchStr}
              />
            </div>
          </div>
          {isLoading && <Spinner active={true} />}
        </div>
      </div>


    </MapWrapper >
  );
};

export default withRouter(VehicleLastPosition);

